export default (function (a, b) {
  return Object.assign({}, a, b);
});